<template>
    <div class="coming-soon">
        <img class="logo-img" :src="logoImg" />
        <img class="tips-img" :src="tipsImg" />
        <p>{{text}}</p>
    </div>
</template>
<script>
export default {
    props: {
        text: {
            type: String,
            default: '敬请期待 蔚来新车发布'
        }
    },
    data() {
        return {
            logoImg: require('../../assets/images/logo.png'),
            tipsImg: require('../../assets/images/coming-soon.png')
        };
    }
};
</script>

<style scoped lang="less">
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';
.coming-soon {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url(../../assets/images/bg_new.png);
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    background-color: #FFFFFF;
    color: #fff;
    .logo-img {
        margin-top: 210 * @layout375;
        width: 140 * @layout375;
        height: 132 * @layout375;
    }
    .tips-img {
        margin-top: 40 * @layout375;
        width: 180 * @layout375;
        height: 32 * @layout375;
        object-fit: contain;
    }
    p {
        margin-top: 10 * @layout375;
        font-weight: 300;
        font-size: 14 * @layout375;
        line-height: 22 * @layout375;
        letter-spacing: -0.25 * @layout375;
        color: #FFFFFF;
    }
}
</style>



// WEBPACK FOOTER //
// src/marketing_components/coming-soon/index.vue